import { Outlet } from "react-router-dom";
import { useAuth } from "react-oidc-context";

import BrandLogo from "@/components/BrandLogo";

export default function PublicLayout() {
  const auth = useAuth();
  const username =
    (auth.user?.profile?.preferred_username as string | undefined) ??
    auth.user?.profile?.email ??
    "—";
  return (
    <div className="cl-min">
      <header className="cl-min__top">
        <BrandLogo />
        <div className="cl-min__top-right">
          <span className="cl-min__user">{username}</span>
          <button
            className="mt-btn mt-btn--ghost mt-btn--sm"
            onClick={() => void auth.signoutRedirect()}
          >
            Выйти
          </button>
        </div>
      </header>
      <main className="cl-min__main">
        <Outlet />
      </main>
    </div>
  );
}
